import { render, staticRenderFns } from "./MarkMusicDetail.vue?vue&type=template&id=a1436daa&scoped=true&"
import script from "./MarkMusicDetail.vue?vue&type=script&lang=js&"
export * from "./MarkMusicDetail.vue?vue&type=script&lang=js&"
import style0 from "./MarkMusicDetail.vue?vue&type=style&index=0&id=a1436daa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1436daa",
  null
  
)

export default component.exports